module.exports = __webpack_public_path__ + "static/media/tShirt2.c931cf4a.jpg";